module.exports = __webpack_public_path__ + "img/recommen-img1.636ccd59.png";